import { ServiceAgreementMetadata, ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { serviceAgreementApi } from 'api';

export const updateServiceAgreementApi = async (
  serviceAgreement: ServiceAgreementV2,
  attribute: ServiceAgreementMetadata[],
): Promise<ServiceAgreementV2> => {
  serviceAgreement.attributes = attribute;
  return await serviceAgreementApi.updateServiceAgreement({
    serviceAgreementUid: serviceAgreement.serviceAgreementId ?? '',
    serviceAgreementV2: serviceAgreement,
  });
};
